interface EnablementBadgeProps {
  percentage: number | null | undefined
  showLabel?: boolean
}

const EnablementBadge: React.FC<EnablementBadgeProps> = ({
  percentage,
  showLabel = false
}) => {
  if (percentage == null) {
    return null
  }

  const colorClass =
    percentage >= 50
      ? 'bg-green-100 text-green-700 dark:bg-green-950 dark:text-green-300'
      : 'bg-orange-100 text-orange-700 dark:bg-orange-950 dark:text-orange-300'

  return (
    <span
      className={`inline-block text-center font-medium py-0.5 rounded ${showLabel ? 'w-24 text-xs' : 'w-10 text-[11px]'} ${colorClass}`}
    >
      {percentage}%{showLabel ? ' enablement' : ''}
    </span>
  )
}

export default EnablementBadge
